import {EventEmitter} from 'events';
import Dispatcher from '../dispatcher';
import assign from 'object-assign';
import 'babel-polyfill';

const DeviceStore = assign({}, EventEmitter.prototype, {

  _state: undefined,
  isLoading: false,

  init: function(){
    Dispatcher.on(Dispatcher.DEVICE_DEACTIVATE_DEVICE, (id) => {
      Jigsaw.User.deactivateDevice(id, (response) => {
        if (response.isSuccess()){
          let device = this.get(id);
          device.active = false;
          Dispatcher.emit(Dispatcher.DEVICE_STORE_CHANGE);
        }
      });
    });
  },

  _updateState: function(state){
    this._state = state;
    Dispatcher.emit(Dispatcher.DEVICE_STORE_CHANGE);
  },

  get: function(id){
    this._load();
    if(!this._state){ return undefined; }

    return this._state.find((d) => {
      return d.id === id
    })
  },

  getAll: function(){
    this._load();
    return this._state;
  },

  _load: function(update){
    if (!this.isLoading && (update || this._state === undefined)){
      this.isLoading = true;
      Jigsaw.User.getDevices(function(response){
        if (response.isSuccess()){
          const activeDevices = response.data.devices.filter(device => device.active)
          this._updateState(activeDevices);
        }else{
          this._updateState([]);
        }
        this.isLoading = false;
      }.bind(this));
    }
  }

});

DeviceStore.init();
export default DeviceStore;
